import Card from "@rio-cloud/rio-uikit/Card";
import ContentLoader from "@rio-cloud/rio-uikit/ContentLoader";

interface KpiCardsSkeletonProps {
  cards?: number;
  className?: string;
  style?: React.CSSProperties;
  contentGapClassName?: string;
  footerExtraWidths?: readonly (number | undefined)[];
}

const KPI_ICON_WRAPPER_STYLE = { width: 56, height: 50, borderRadius: 6 } as const;
const KPI_FOOTER_STYLE = { fontSize: 15 } as const;

const KPI_LABEL_LINE_HEIGHT = 26;
const KPI_VALUE_LINE_HEIGHT = 34;
const KPI_FOOTER_LINE_HEIGHT = 21;
const KPI_FOOTER_GLYPH_HEIGHT = 15;

const DEFAULT_GRID_CLASS_NAME = "display-grid grid-cols-1 grid-cols-2-sm grid-cols-4-lg gap-10";

export default function KpiCardsSkeleton({
  cards = 4,
  className = DEFAULT_GRID_CLASS_NAME,
  style,
  contentGapClassName = "gap-15",
  footerExtraWidths = [],
}: Readonly<KpiCardsSkeletonProps>) {
  return (
    <div className={className} style={style}>
      {Array.from({ length: cards }, (_, index) => {
        const footerExtraWidth = footerExtraWidths[index];

        return (
          <Card key={index} padding={0} className="overflow-hidden display-flex flex-column height-100pct">
            <div className="padding-15 flex-1-1">
              <div className={`display-flex align-items-center ${contentGapClassName}`}>
                <ContentLoader
                  className="flex-0"
                  height={KPI_ICON_WRAPPER_STYLE.height}
                  width={KPI_ICON_WRAPPER_STYLE.width}
                  rx={KPI_ICON_WRAPPER_STYLE.borderRadius}
                  ry={KPI_ICON_WRAPPER_STYLE.borderRadius}
                />
                <div className="display-flex flex-column gap-2 min-width-0">
                  <ContentLoader height={KPI_LABEL_LINE_HEIGHT} width={110} />
                  <ContentLoader height={KPI_VALUE_LINE_HEIGHT} width={150} />
                </div>
              </div>
            </div>
            <div
              className="display-flex flex-wrap align-items-center bg-lighter padding-y-10 padding-x-20"
              style={KPI_FOOTER_STYLE}
            >
              <span className="display-flex align-items-center gap-2">
                <ContentLoader height={KPI_FOOTER_GLYPH_HEIGHT} width={KPI_FOOTER_GLYPH_HEIGHT} />
                <ContentLoader height={KPI_FOOTER_LINE_HEIGHT} width={32} />
              </span>
              <span className="margin-left-5 display-flex align-items-center">
                <ContentLoader height={KPI_FOOTER_LINE_HEIGHT} width={100} />
              </span>
              {footerExtraWidth ? (
                <span className="margin-left-15 display-flex align-items-center">
                  <ContentLoader height={KPI_FOOTER_LINE_HEIGHT} width={footerExtraWidth} />
                </span>
              ) : null}
            </div>
          </Card>
        );
      })}
    </div>
  );
}
